$.fn.hasAttr = function(name) {  
   return this.attr(name) !== undefined;
};
function AddReadMore() {
  var carLmt = 180;
  var readMoreTxt = "... Read More";
  var readLessTxt = " Read Less";

  //Traverse all selectors with this class and manupulate HTML part to show Read More
  jQuery(".addReadMore").each(function () {
    if (jQuery(this).find(".firstSec").length) return;

    var allstr = jQuery(this).find("p").text();
    if (allstr.length > carLmt) {
      var firstSet = allstr.substring(0, carLmt);
      var secdHalf = allstr.substring(carLmt, allstr.length);
      var strtoadd =
        firstSet +
        "<span class='SecSec'>" +
        secdHalf +
        "</span><span class='readMore'  title='Click to Show More'>" +
        readMoreTxt +
        "</span><span class='readLess' title='Click to Show Less'>" +
        readLessTxt +
        "</span>";
      jQuery(this).find("p").html(strtoadd);
    }
  });
  //Read More and Read Less Click Event binding
  jQuery(document).on("click", ".readMore,.readLess", function () {
    window.dispatchEvent(new Event("resize"));
    jQuery(this)
      .closest(".addReadMore")
      .toggleClass("showlesscontent showmorecontent");
  });
}

document.addEventListener('recommendations:loaded', function(evt) {
  // doSwatchSlider();
});

function isSample(variant_option) {
    if (variant_option &&  variant_option != null && (
        variant_option == "Sample" || 
        variant_option == "Sample X" || 
        variant_option == "Sample O" || 
        variant_option == "Single Tile" || 
        variant_option == "Sample (2 pcs)" || 
        variant_option == "Sample (4 pcs)" || 
        variant_option == "Single Sheet" || 
        variant_option == "Single Sheet (1 sqft)" || 
        variant_option == "Full Sheet 1sqft" ||
        variant_option == "Sample 8x8"
      )
    ){
        return false; // Variant option meets conditions
    } else {
        return true; // Variant option does not meet conditions
    }
}

function doSwatchSlider() {
  
  $(".grid-product__colors").each(function () {
    let $el = $(this);

    if ($el.find(".color-swatch.is-on-sale").length) {
      // If there are any .on-sale swatches, reorder them to the start
      let $onSaleSwatches = $el.find(".color-swatch.is-on-sale");
      let $otherSwatches = $el.find(".color-swatch:not(.is-on-sale)");

      $el.html(""); // Clear existing swatches
      $el.append($onSaleSwatches); // Add .on-sale swatches first
      $el.append($otherSwatches); // Add the rest
    }

    let countedVariants = [];

    $el.find(".color-swatch.sale-swatches").each(function (i) {
      
      let vid = $(this).data("vid");
      let actual_area = $(this).data("sqprice");
      let vprice = $(this).data("vprice");
      let $swatch = $(this);
      
      let sq_price = parseFloat(vprice) / parseFloat(actual_area);
      if (isNaN(sq_price) || $swatch.hasAttr("data-issqft")) {
        sq_price = $swatch.data("vprice");
      }
      sq_price = theme.Currency.formatMoney(sq_price, theme.settings.moneyFormat);
      $swatch.attr("data-sqprice", sq_price);
      
    });

    
    $el.find(".color-swatch:not(.sale-swatches)").each(function (i) {
      let jsonText = $(this).parents(".grid-product").find(".wcp_json").text();
      if(jsonText){
        let WCP_JSON = JSON.parse(jsonText);  
        let vid = $(this).data("vid");
        let actual_area = $(this).data("sqprice");
        let $swatch = $(this);
        $.each(WCP_JSON.variants, function (i, variant) {
          let variant_option = variant.option3 !== null ? variant.option3 : variant.option2;
          if (isSample(variant_option)) {
            if (countedVariants.includes(variant.id) == false && variant) {
              let sq_price = parseFloat(variant.price) / parseFloat(actual_area);
              if (isNaN(sq_price) || $swatch.hasAttr("data-issqft")) {
                sq_price = $swatch.data("vprice");
              }
              sq_price = theme.Currency.formatMoney(sq_price, theme.settings.moneyFormat);
              $swatch.attr("data-sqprice", sq_price);
              countedVariants.push(variant.id);
              return false;
            }
          }
        });
      }
    });

    let maxShowDesktop = 6;
    let maxShowMobile = 5;
    if ($el.parents(".grid-product").hasClass("new__product-grid")) {
      maxShowMobile = 9;
    }
    if (
      (window.innerWidth > 500 && $el.find(".color-swatch").length > maxShowDesktop) ||
      (window.innerWidth < 500 && $el.find(".color-swatch").length >= maxShowMobile)
    ) {
      let swatchslider = $el.flickity({
        cellAlign: "left",
        pageDots: false,
        draggable: false,
        wrapAround: true,
        on: {
          ready: function () {
            $el
              .find("button.flickity-button.flickity-prev-next-button.previous")
              .html(
                '<svg class="flickity-button-icon prev-fk" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 128 128" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M44 108a3.988 3.988 0 0 1-2.828-1.172 3.997 3.997 0 0 1 0-5.656L78.344 64 41.172 26.828c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0l40 40a3.997 3.997 0 0 1 0 5.656l-40 40A3.988 3.988 0 0 1 44 108z" fill="#333333" opacity="1" data-original="#000000" class=""></path></g></svg>'
              );
            $el
              .find("button.flickity-button.flickity-prev-next-button.next")
              .html(
                '<svg class="flickity-button-icon" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 128 128" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M44 108a3.988 3.988 0 0 1-2.828-1.172 3.997 3.997 0 0 1 0-5.656L78.344 64 41.172 26.828c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0l40 40a3.997 3.997 0 0 1 0 5.656l-40 40A3.988 3.988 0 0 1 44 108z" fill="#333333" opacity="1" data-original="#000000" class=""></path></g></svg>'
              );
          },
        },
      });

      $el.fadeIn();

      setTimeout(function () {
        swatchslider.flickity('resize');
        console.log('resized')
      }, 500);
        
    }
    
$el.fadeIn();
  
  });


}




document.addEventListener('infinite:loaded', (event) => {
  doSwatchSlider();
});


jQuery(document).ready(function () {

  document.querySelectorAll('.more-terms-anchor').forEach(anchor => {
      anchor.addEventListener('click', function () {
          const parent = this.closest('.CartTermsHeaderLabel'); 
          const moreTerms = parent.querySelector('.more-terms');
          if (moreTerms.style.display === 'inline') {
              moreTerms.style.display = 'none';
              this.textContent = 'Read More';
          } else {
              moreTerms.style.display = 'inline';
              this.textContent = 'Read Less';
          }
      });
  });

  $(document).on('click','.cart__item-row.cart__checkout-wrapper.payment-buttons,.cart__item-row.cart__checkout-wrapper', function(){ 
      if(!$('input#CartTermsHeader:checked').val()){
          //alert(theme.strings.cartTermsConfirmation);
          $('.cart__item-row.cart__terms').addClass('notgtg');
      }
  });
  
  $(document).on('change',"input#CartTermsHeader",function(){
      if($(this).is(':checked')){
          $(this).parents('.cart__item-row.cart__terms').removeClass('notgtg');
          $(".cart__item-row.cart__checkout-wrapper.payment-buttons,.cart__item-row.cart__checkout-wrapper").addClass('okay');
      }else{
          alert(theme.strings.cartTermsConfirmation);
          $(this).parents('.cart__item-row.cart__terms').addClass('notgtg');
         $(".cart__item-row.cart__checkout-wrapper.payment-buttons,.cart__item-row.cart__checkout-wrapper").removeClass('okay');
      }
  });
  

  doSwatchSlider();
  
  var $temp = $("<input>");
  var $url = $(location).attr('href');
  
  $('a.social-sharing__link.copylink').on('click', function(e) {
    e.preventDefault();
    $("body").append($temp);
    $temp.val($url).select();
    document.execCommand("copy");
    $temp.remove();
  })
  
  AddReadMore();
  
  setTimeout(function () {
    window.dispatchEvent(new Event("resize"));
  }, 2000);

  featured_slider();

  document.addEventListener("shopify:section:load", function () {
    featured_slider();
  });

  $(document).on('click','.cart__remove .text-link', function(e){
      e.preventDefault();
      let key = $(this).attr('data-key');
      let _this = this;
      theme.cart.changeItem(key, 0).then(function(cart) {
        theme.cart.updateCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: cart
          }
        }));
        $(_this).parents('.cart__item').fadeOut();
      });
  });

  $('.designer__slider').flickity({
    adaptiveHeight: true,
    pageDots: false,
    prevNextButtons: true, 
  });
  
});

$(document).on("change",".tabset input",function name(params) {
    var get_checl = $('.tabset input:checked').attr('aria-controls');
   // $(this).parents('.tabset').css('height',$('.tab-panels').innerHeight());
  $('.tab-panels section').removeAttr('style');
    $('.tab-panels section').addClass('slider_displayNone');
    $('.tab-panels [id="'+get_checl+'"]').removeClass('slider_displayNone');

    setTimeout(function(){
      let $el = $(".grid-product__colors");
      $el.flickity('resize');
    },600);
})

// $(document).on("click", ".variant__button-label", function (e) {
//   setTimeout(function(){
//     var variant_selected = $('.product-single__meta .product-single__variants[name="id"]').val();
//     $(".tt-label.pdp").find("div").hide();
//     $(".tt-label.pdp").find('div[vv_id="' + variant_selected + '"]').show();
//   },200);
// });

//Featured collection slider for home page
function featured_slider() {
  //alert('sliderrrrrr');  
  var elem = document.querySelector('.new-grid.product-grid[data-f-slider="true"]');
  if(elem){
    
    var slider = new Flickity( elem, {
      adaptiveHeight: false,
        avoidReflow: true,
        pageDots: false,
        wrapAround: true,
        prevNextButtons: true,
        groupCells: true,
        cellAlign: 'left'
    });
  
    var progressBar = document.querySelector('.progress-bar')
    slider.on( 'scroll', function( progress ) {
      progress = Math.max( 0, Math.min( 1, progress ) );
      progressBar.style.width = progress * 100 + '%';
    });
    
    // setTimeout(function () {
    //   slider.flickity("resize");
    // }, 500);

  }
  
}

$(document).on('click', function(){
  $('.bd-share-button .social-sharing').removeClass('active');
});
$(document).on('click','.bd-share-button > span', function(e){
    e.stopPropagation();
    $(this).next().toggleClass('active');
});

//Featured collections tab
$(document).on('click','.tabset input',function() {
    var curnt_hndle = $(this).attr('data-collection-tab');
    var _thsParent = $(this)
    if($('.tab-panels .product-grid[data-collection-handle="'+curnt_hndle+'"] .grid-item').length < 1){
      $.ajax({
        type: 'GET',
        url: '/collections/'+curnt_hndle+'?view=main-collection-original',
        beforeSend: function(){
           $('.tabs-cust-loader').css('display','block')
        },
        success: function(data) {
          var filteredData = $(data).find("[data-scroll-to]").html();
          $('.tabs-cust-loader').css('display','none')
          $('.tab-panels .product-grid[data-collection-handle="'+curnt_hndle+'"]').html(filteredData);
          setTimeout(function(){
            $('.product-grid[data-collection-handle="'+curnt_hndle+'"]').removeClass('flickity-enabled');
            var elem = document.querySelector('.product-grid[data-collection-handle="'+curnt_hndle+'"]');
            var slider = new Flickity( elem, {
              adaptiveHeight: false,
              avoidReflow: true,
              pageDots: false,
              wrapAround: true,
              prevNextButtons: true, 
              groupCells: true,
              cellAlign: 'left'
            });
          
            var progressBar = document.querySelector('.product-grid[data-collection-handle="'+curnt_hndle+'"] + .progress-bar')
            slider.on( 'scroll', function( progress ) {
              progress = Math.max( 0, Math.min( 1, progress ) );
              progressBar.style.width = progress * 100 + '%';
            });

              // if (typeof loadReviewsIoRatingSnippets === "function") {
              //   loadReviewsIoRatingSnippets();
              // } else {
              //   // If script is loaded asynchronously, retry until it's available
              //   const interval = setInterval(function () {
              //     if (typeof loadReviewsIoRatingSnippets === "function") {
              //       clearInterval(interval);
              //       loadReviewsIoRatingSnippets();
              //     }
              //   }, 300);
              // }

            
             $('.product-grid[data-collection-handle="'+curnt_hndle+'"]').removeClass('flex_slider');
            // setTimeout(function name(params) {
            //    $('.tab-panel .color-swatch').hover(function(){
            //     var _this = $(this);
            //     var _ths_id =  _this.attr('data-variant-id')
            //     var _ths_url = _this.attr('data-url')
            //     var _ths_price = _this.attr('data-sqprice')
            //     var _ths_bg = _this.attr('style')
            //     var _ths_image = _this.attr('data-variant-image');
            //     _this.parents('.grid-item__meta').find('.grid_tags .p_tag').css('display','none');
            //     _this.parents('.grid-item').find('.grid-item__link').attr('href',_ths_url);
            //     _this.parents('.grid-item').find('.grid-product__color-image.grid-product__color-image--'+_ths_id).attr('style',_ths_bg);
            //     _this.parents('.grid-item').find('.grid-product__color-image').removeClass('is-active')
            //     _this.parents('.grid-item').find('.grid-product__color-image.grid-product__color-image--'+_ths_id).addClass('is-active')
            //     _this.parents('.grid-item__meta').find('.grid_tags .p_tag').each(function(){  
            //       var _each_this = $(this);
            //       if(_each_this.attr('vv_id') == _ths_id ){
            //         _each_this.removeAttr('style')
            //       }
            //     })
            //   }, function () {
            //      var _this = $(this);
            //     _this.parents('.grid-item').find('.grid-product__color-image').removeClass('is-active')
            //   });
            // })
          })
          let collection = new theme.Collection(_thsParent.parents('.tabs-collection')[0]);
          doSwatchSlider();
          
        },
        dataType: "html"
      });   
   }
});

$(window).on("resize",function(e){
  setTimeout(function() {
    var $carousel_tab = $('.tabs-collection .new-grid.product-grid');
    $carousel_tab.removeClass('flex_slider');
    if(!$carousel_tab.hasClass('flickity-enabled')){
      $carousel_tab.flickity({
        adaptiveHeight: false,
        avoidReflow: true,
        pageDots: false,
        wrapAround: true,
        prevNextButtons: true, 
        groupCells: true,
        cellAlign: 'left'
      });
    }
  },50);
});


// setTimeout(function() {
//   $('.grid-item__meta .color-swatch').hover(function(){
//     var _this = $(this);
//     var _ths_id =  _this.attr('data-variant-id')
//     var _ths_url = _this.attr('data-url')
//     var _ths_price = _this.attr('data-sqprice')
//     var _ths_bg = _this.attr('style')
//     var _ths_image = _this.attr('data-variant-image');
//     _this.parents('.grid-item__meta').find('.grid_tags .p_tag').css('display','none');
//     // if(data-sqprice != ""){
//     //    _this.parents('.grid-item__meta').find('.grid-product__price .grid-product__price--current').text(_ths_price);
//     // }
//     _this.parents('.grid-item').find('.grid-item__link').attr('href',_ths_url);
//     _this.parents('.grid-item').find('.grid-product__color-image.grid-product__color-image--'+_ths_id).attr('style',_ths_bg);
//     _this.parents('.grid-item').find('.grid-product__color-image').removeClass('is-active')
//     _this.parents('.grid-item').find('.grid-product__color-image.grid-product__color-image--'+_ths_id).addClass('is-active')
//     _this.parents('.grid-item__meta').find('.grid_tags .p_tag').each(function(){  
//       var _each_this = $(this);
//       if(_each_this.attr('vv_id') == _ths_id ){
//         _each_this.removeAttr('style')
//       }
//     })
//   })
//   setTimeout(function name(params) {
//       $(function () {
//         $('.grid-item__meta .color-swatch').hover(function () {
//               var _this = $(this);
//         var _ths_id =  _this.attr('data-variant-id')
//         var _ths_url = _this.attr('data-url')
//         var _ths_price = _this.attr('data-sqprice')
//         var _ths_bg = _this.attr('style')
//         var _ths_image = _this.attr('data-variant-image');
//         _this.parents('.grid-item__meta').find('.grid_tags .p_tag').css('display','none');
//         // if(data-sqprice != ""){
//         //    _this.parents('.grid-item__meta').find('.grid-product__price .grid-product__price--current').text(_ths_price);
//         // }
//         _this.parents('.grid-item').find('.grid-item__link').attr('href',_ths_url);
//         _this.parents('.grid-item').find('.grid-product__color-image.grid-product__color-image--'+_ths_id).attr('style',_ths_bg);
//         _this.parents('.grid-item').find('.grid-product__color-image').removeClass('is-active')
//         _this.parents('.grid-item').find('.grid-product__color-image.grid-product__color-image--'+_ths_id).addClass('is-active')
//         _this.parents('.grid-item__meta').find('.grid_tags .p_tag').each(function(){  
//           var _each_this = $(this);
//           if(_each_this.attr('vv_id') == _ths_id ){
//             _each_this.removeAttr('style')
//           }
//         })
//         }, function () {
//            var _this = $(this);
//           _this.parents('.grid-item').find('.grid-product__color-image').removeClass('is-active')
//         });
//     });
// },1500)
  
//   $(document).on('click','.slide-nav__link--back',function(e){
//     e.preventDefault();
//     var _this = $(this);
//     if($(this).parents('ul').attr('data-level') == 3){
//        _this.parents('.slide-nav__wrapper').attr('data-level','2');
//         _this.parents('.slide-nav__wrapper').find('.slide-nav__dropdown[data-level="2"]').eq(0).addClass('is-active')
//     }
// })
// },500)

$(window).on("load resize", function() {
	//Grouts grid slider
	if($(window).width() <= 980) {
		var $grout_slider = $('.grouts-main');
        if(!$grout_slider.hasClass('flickity-enabled')){
          $grout_slider.flickity({
            adaptiveHeight: false,
            avoidReflow: true,
            pageDots: false,
            wrapAround: true,
            prevNextButtons: true, 
            groupCells: true,
            cellAlign: 'left'
          });
        }
	} else {
		$(".grouts-main").flickity('destroy');
	}

    if($(window).width() <= 1023) {
		var $recommendation_slider = $('.product-recommendations .scrollable-grid--small');
        if(!$recommendation_slider.hasClass('flickity-enabled')){
          $recommendation_slider.flickity({
            adaptiveHeight: false,
            avoidReflow: true,
            pageDots: false,
            wrapAround: true,
            prevNextButtons: true, 
            groupCells: true,
            cellAlign: 'left'
          });
        }
	} else {
		$(".product-recommendations .scrollable-grid--small").flickity('destroy');
	}
});


document.querySelectorAll('.mustbeinstalledwith .color-swatch').forEach(swatch => {
    swatch.addEventListener('mouseenter', function () {
        const dataVid = this.getAttribute('data-vid');
        const dataVariantImage = this.getAttribute('data-variant-image');
        const parentProduct = this.closest('.grid-item.grid-product');
        const targetImage = parentProduct.querySelector(`.grid-product__color-image--${dataVid}`);

        if (targetImage) {
            targetImage.classList.add('is-active');
            targetImage.style.background = `url(${dataVariantImage}) no-repeat center / contain`;
        }
    });

    swatch.addEventListener('mouseleave', function () {
        const dataVid = this.getAttribute('data-vid');
        const parentProduct = this.closest('.grid-item.grid-product');
        const targetImage = parentProduct.querySelector(`.grid-product__color-image--${dataVid}`);

        if (targetImage) {
            setTimeout(() => {
                targetImage.classList.remove('is-active');
                targetImage.style.background = '';
            }, 300); // 300ms delay
        }
    });
});

